import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { Tierreklamation } from '../../classes/tierreklamation';
import { UntypedFormControl } from '@angular/forms';
import { MessageService } from '../../../../services/message-service/message.service';
import { StammdatenService } from '../../../stammdaten/stammdaten.service';
import { forkJoin, Subscription } from 'rxjs';

@Component({
    selector: 'kiene-gruppe-tier-reklamation-filter',
    templateUrl: './gruppe-tier-tier-reklamation-filter.component.html',
    styleUrls: ['./gruppe-tier-tier-reklamation-filter.component.scss'],
})
export class GruppeTierTierReklamationFilterComponent implements OnInit, OnDestroy, OnChanges {
    tierReklamationenGruppeSubscription: Subscription;
    isLoading = true;
    label = 'Lädt...';

    @Input('gruppeId') gruppeId: number;
    @Input() gruppeIds: number[] = [];
    @Input('reklamationen') reklamationen: Tierreklamation[] = [];
    @Input('hideOnEmptyList') hideOnEmptyList = false;
    @Output('selectedReklamationen') selectedReklamationen: EventEmitter<Tierreklamation[]> = new EventEmitter<
        Tierreklamation[]
    >();
    selectedReklamationCtrl: UntypedFormControl = new UntypedFormControl(null);
    reklamationenFuerGruppe: Tierreklamation[] = [];

    constructor(
        private readonly messageService: MessageService,
        private readonly stammdatenService: StammdatenService,
    ) {}

    ngOnDestroy(): void {
        this.tierReklamationenGruppeSubscription?.unsubscribe();
    }
    ngOnInit(): void {
        this.loadTierReklamationenFuerGruppe();

        this.selectedReklamationCtrl.setValue(this.reklamationen);

        this.selectedReklamationCtrl.valueChanges.subscribe(data => {
            this.selectedReklamationen.emit(data);
        });
    }

    ngOnChanges() {
        this.loadTierReklamationenFuerGruppe();
    }

    private loadTierReklamationenFuerGruppe() {
        const targetGroupIds =
            (this.gruppeIds || []).map(id => Number(id)).filter(id => id > 0).length > 0
                ? (this.gruppeIds || []).map(id => Number(id)).filter(id => id > 0)
                : this.gruppeId
                  ? [Number(this.gruppeId)]
                  : [];
        if (targetGroupIds.length > 0) {
            this.isLoading = true;
            this.tierReklamationenGruppeSubscription?.unsubscribe();
            const requests = targetGroupIds.map(gruppeId => this.stammdatenService.ladeTierreklamationen(gruppeId));
            this.tierReklamationenGruppeSubscription = forkJoin(requests).subscribe({
                    next: result => {
                        this.isLoading = false;
                        const byId = new Map<number, Tierreklamation>();
                        for (const res of result || []) {
                            for (const item of res?.records || []) {
                                const key = Number(item?.tierreklamation_id || 0);
                                if (key <= 0 || byId.has(key)) {
                                    continue;
                                }
                                byId.set(key, item);
                            }
                        }
                        this.reklamationenFuerGruppe = Array.from(byId.values());
                        this.reklamationenFuerGruppe.sort((a, b) => {
                            return a.reklamation < b.reklamation ? -1 : 1;
                        });

                        if (this.reklamationenFuerGruppe.length === 0) {
                            this.label = 'keine Reklamationen';
                            this.selectedReklamationCtrl.disable();
                        } else {
                            this.label = 'Reklamation';
                        }
                    },
                    error: err => {
                        this.isLoading = false;
                        this.messageService.errorMessage('Fehler beim Laden der Tierreklamationen', err);
                    },
                });
        }
    }

    resetReklamationCtrl($event: MouseEvent) {
        $event.stopPropagation();
        this.selectedReklamationCtrl.setValue(undefined);
    }

    compareReklamation(a: Tierreklamation, b: Tierreklamation) {
        return a && b && a.tierreklamation_id === b.tierreklamation_id;
    }
}
